import { getCookie } from '@sparx/sw-common';

export const SESSION_COOKIE_NAME = settings.sessionCookieName || 'sparxweb_cookie';

export const CSRF_COOKIE_NAME = settings.csrfCookieName || 'sparxweb_csrf';

export function readSessionCookie() {
    return getCookie(SESSION_COOKIE_NAME);
}

export function readCSRFCookie() {
    return getCookie(CSRF_COOKIE_NAME);
}

export function writeSessionCookie(sessionCookie) {
    const cookieToWrite = SESSION_COOKIE_NAME + '=' + sessionCookie + '; path=/;';
    document.cookie = cookieToWrite;
}

export function deleteSessionCookie() {
    deleteCookie(SESSION_COOKIE_NAME);
}

function deleteCookie(cookie_name) {
    const cookieToDelete = cookie_name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/;';
    document.cookie = cookieToDelete;
}
